var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "toast", staticClass: "toast", class: _vm.className },
    [
      _c("div", {
        staticClass: "toast__text",
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _vm._v(" "),
      _c("button", { staticClass: "toast__close", on: { click: _vm.close } }, [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M1.66675 1.66669L12.8282 12.8281M12.8282 1.66669L1.66678 12.8281",
                stroke: "#3A405B",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }